import { getProductDetails } from '../../apiCalls/urls/urlFunction';
import { isDiscountedProduct } from '../../hooks/utilsFn/utilsFn';

export const validateOutOfStock = (productStatus, denomType) => {
    let response = {
        outOfStock: false,
        rangeDenomination: false,
    };

    if (productStatus === 'ACTIVE') {
        if (denomType === "RANGE") {
            response.outOfStock = false;
            response.rangeDenomination = true;
            return response;
        }

        response.outOfStock = false;
        response.rangeDenomination = false;
        return response;
    }

    if (productStatus === 'OUT_OF_STOCK') {
        response.outOfStock = true;
        response.rangeDenomination = false;
        return response;
    }

    return response;

    // if (isRange == 1 && front !== 0) {
    //   response.outOfStockStatus = true;
    //   response.rangeDenominationStatus = true;
    // } else if (isRange == 1 && front == 0 && denom?.length < 1) {
    //   response.rangeDenominationStatus = true;
    //   response.outOfStockStatus = false;
    // } else if (isRange !== 1 && front == 0 && denom?.length > 0) {
    //   response.outOfStockStatus = false;
    //   response.rangeDenominationStatus = false;
    // } else if (isRange !== 1 && front !== 0) {
    //   response.outOfStockStatus = true;
    //   response.rangeDenominationStatus = false;
    // } else if (isRange !== 1 && front == 0 && denom?.length < 1) {
    //   response.outOfStockStatus = true;
    //   response.rangeDenominationStatus = false;
    // }

    // THis Logic is work properly
    // if (apiId == 5 && front !== 0) {
    //     response.outOfStockStatus = true;
    //     response.rangeDenominationStatus = true;
    // } else if (apiId == 5 && front == 0 && denom?.length < 1) {
    //     response.rangeDenominationStatus = true;
    //     response.outOfStockStatus = false;
    // } else if (apiId !== 5 && front == 0 && denom?.length > 0) {
    //     response.outOfStockStatus = false;
    //     response.rangeDenominationStatus = false;
    // } else if (apiId !== 5 && front !== 0) {
    //     response.outOfStockStatus = true;
    //     response.rangeDenominationStatus = false;
    // } else if (apiId !== 5 && front == 0 && denom?.length < 1) {
    //     response.outOfStockStatus = true;
    //     response.rangeDenominationStatus = false;
    // }

    return response;

    // return response;
    /**
     * denomination.api_id == 5 && denomination.front == 0 => Card Range
     * denomination.api_id == 5 &&  denomination.front !== 0 => Currently Out Of Stock
     * denomination.api_id !== 5 && denomination.front !== 0 => Currently Out Of Stock
     * denomination.api_id !== 5 && denomination.front === 0 => Currently Out Of Stock
     **/
};

export const isProductLive = (status) => {
    if (status === 'ACTIVE') {
        return true;
    }
    return false;
};

export const fetchProductById = async (urlId) => {
    try {
        return await getProductDetails(urlId);
    } catch (error) { }
};

export const isDenominationAvailable = (denoData) => {

    let response = {
        isDenominationAvailableStatus: true,
    };

    if (!denoData?.length) {
        response.isDenominationAvailableStatus = false;
    }

    return response;
};

export const createDenominationData = (data) => {
    const newDenoData = data?.denominations?.map((item) => {
        return {
            AMOUNT: item?.amount,
            DISCOUNT: item?.discount || data?.discount || 0,
            QUANTITY: 0,
            TOTAL: 0,
            MAX_LIMIT: item?.maxLimit || data?.max_quantity || 5,
            DENOM_TYPE: item?.denomType || 'FIXED',
            PRODUCT_CODE: item?.PRODUCTCODE || null,
            PRODUCT_GUID: item?.ProductGuid || null,
            PRODUCT_ID: item?.product_id || null,
            SUB_PRODUCT_ID: item?.subproduct_id || null,
            SKU_ID: item?.skuID || null,
            ISCASHBACK_PRODUCT: item?.denomType === 'CASHBACK',
            PRODUCT_TYPE: data?.productType || null,
            CASHBACK_AMOUNT: item?.denomType === 'CASHBACK' ? item?.discount : null,
            ...item
        };
    });
    return newDenoData;
};


export const productDetailApiCall = async (urlId) => {
    let response = {
        status: true,
        message: null,
        data: null
    };
    try {
        const apiResponse = await getProductDetails(urlId);
        if (!apiResponse?.status) {
            response.status = false;
            response.message = apiResponse?.message;
            return response;
        }


        let product = { ...apiResponse?.data?.product || {} };

        // Discount Check
        const { productType, discount } = isDiscountedProduct(product?.discount);
        product.productType = productType;
        product.discount = discount;
        product.isCashbackProduct = productType === "Cashback";

        // Stock Check
        const { outOfStock, rangeDenomination } = validateOutOfStock(product?.status, product?.denomType);
        product.rangeDenomination = rangeDenomination;
        product.outOfStock = outOfStock;


        // Denomination data have
        if (!outOfStock && !rangeDenomination) {
            const newDeno = createDenominationData(product);
            product.newDeno = newDeno;
        }

        if (!outOfStock && rangeDenomination) {
            product.min_price = product?.denominations?.[0]?.minAmount || 0;
            product.max_price = product?.denominations?.[0]?.maxAmount || 0;
        }

        response.data = product;
        return response;

    } catch (error) {
        console.error(error);
    }
};
